import React, { ChangeEvent, InputHTMLAttributes } from "react"

import * as Styles from "./TextInput.styles"

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>((props, ref) => {
  const { label, isRequired, ...inputProps } = props
  return <Styles.Container>
    <Styles.Label>{label} {isRequired ? "*" : ""}</Styles.Label>
    <Styles.Input
      {...inputProps}
      required={isRequired}
      ref={ref}
      disabled={props.isDisabled}
    />
  </Styles.Container>
})

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string,
  isDisabled?: boolean,
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void,
  isRequired?: boolean,
}
